/** Storefront listeners live in prem-freemium-ribbon.js; kept for card-product script tag compatibility. */
(function () {
  if (window.__premReportStorefrontInit) return;
  window.__premReportStorefrontInit = true;
  if (typeof window.handlePremReportDisplay !== 'function') {
    window.handlePremReportDisplay = function () {
      if (typeof window.ds2RefreshPremFreeRibbonFromCart === 'function') {
        window.ds2RefreshPremFreeRibbonFromCart();
      }
    };
  }
})();
